import React from "react";
import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { Button } from "../../";
import { FormInput } from "../../forms";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { ConfirmDeleteModalProps } from "./types";
import ThemedModal from "../../utilities/ThemedModal";

const DialogBody = styled(Modal.Body)``;

export const ConfirmDeleteModal = ({
    backdrop = 'static',
    cancel,
    centered = true,
    defaultValues,
    dialogId,
    dismiss,
    message = (<p>Are you sure you want to delete this entity? It may not be recoverable.</p>),
    metadata,
    proceed,
    show,
    size = undefined,
    title,
    ...rest
} : Readonly<ConfirmDeleteModalProps>) => {
    const [bodyAnimation] = useAutoAnimate();
    const [challengeInput, setChallengeInput] = React.useState<string>("");
    const { challenge } = metadata;
    const isValid = !challenge || challengeInput === challenge;

    const onClose = () => cancel!();

    return (
        <Modal className="overflow-visible" backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header closeButton>
                <Modal.Title>{title ?? 'Delete Entity?'}</Modal.Title>
            </ThemedModal.Header>
            <DialogBody ref={bodyAnimation}>
                {message}
                {challenge && message && (<hr/>)}
                {challenge && (
                    <div>
                        <FormInput 
                            label={`Please type the name of the document to confirm.`}
                            disableAnimations={false}
                            onChange={(v: any) => setChallengeInput(v.target.value)}
                        />
                    </div>
                )}
            </DialogBody>
            <Modal.Footer>
                <Button variant="danger" onClick={onClose} disabled={!isValid}>Yes, Delete</Button>
                <Button variant="light" onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};